import { gql } from '@apollo/client';

export const TOGGLE_ADVERTISING_ZONE_PRICE_SURVEY = gql(/* GraphQL */ `
    mutation ToggleAdvertisingZonePriceSurvey(
        $input: ToggleAdvertisingZonePriceSurveyInput!
    ) {
        toggleAdvertisingZonePriceSurvey(input: $input) {
            successful
        }
    }
`);
